import React from 'react';

type StatusVariant = 'healthy' | 'degraded' | 'down' | 'loading' | 'inactive';

interface StatusDotProps {
  status: StatusVariant;
  label?: string;
  pulse?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const STATUS_COLORS: Record<StatusVariant, string> = {
  healthy: 'bg-green-500',
  degraded: 'bg-yellow-500',
  down: 'bg-red-500',
  loading: 'bg-blue-500',
  inactive: 'bg-gray-400',
};

const STATUS_LABELS: Record<StatusVariant, string> = {
  healthy: 'Healthy',
  degraded: 'Degraded',
  down: 'Down',
  loading: 'Loading',
  inactive: 'Inactive',
};

const SIZES: Record<string, string> = {
  sm: 'w-2 h-2',
  md: 'w-2.5 h-2.5',
  lg: 'w-3 h-3',
};

export default function StatusDot({
  status,
  label,
  pulse = status === 'healthy' || status === 'loading',
  size = 'md',
}: StatusDotProps) {
  const showLabel = label ?? STATUS_LABELS[status];

  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="relative flex">
        {pulse && (
          <span
            className={`absolute inline-flex h-full w-full rounded-full opacity-40 ${STATUS_COLORS[status]} animate-pulse-dot`}
          />
        )}
        <span className={`relative inline-flex rounded-full ${SIZES[size]} ${STATUS_COLORS[status]}`} />
      </span>
      {showLabel && (
        <span className="text-sm font-medium text-gray-700">{showLabel}</span>
      )}
    </span>
  );
}
